<template>
  <section class="product-cards">
    <div
      class="product-card"
      v-for="(type, index) in accountTypes"
      :key="index"
      @click="setAccountType(type)"
    >
      <div class="product-card__icon">
        <svg v-if="type.title === 'Private Raise'" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="type.title === 'Employee Benefit'" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M20.84 4.61C20.3292 4.09924 19.7228 3.69397 19.0554 3.41712C18.3879 3.14027 17.6725 2.99725 16.95 2.99725C16.2275 2.99725 15.5121 3.14027 14.8446 3.41712C14.1772 3.69397 13.5708 4.09924 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99786 7.05 2.99786C5.59096 2.99786 4.19169 3.57831 3.16 4.61C2.1283 5.6417 1.54785 7.04097 1.54785 8.5C1.54785 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.3508 11.8792 21.756 11.2728 22.0329 10.6054C22.3097 9.93789 22.4527 9.22249 22.4527 8.5C22.4527 7.77751 22.3097 7.0621 22.0329 6.39464C21.756 5.72718 21.3508 5.12075 20.84 4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="type.title === 'API Client'" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M16 18L22 12L16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6L2 12L8 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="type.title === 'Credit Provider'" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <path d="M1 10H23" stroke="currentColor" stroke-width="2"/>
        </svg>
        <svg v-else-if="type.title === 'Treasury'" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M12 1V23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="product-card__content">
        <div class="product-card__header">
          <h3 class="product-card__title">{{ type.title }}</h3>
          <svg class="product-card__arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="product-card__description">{{ getShortText(type.title) }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AccountTypeForm",

  data() {
    return {
      accountTypes: [
        {
          title: "Private Raise",
          description: "Use our private raise infrastructure through dealrooms to raise privately from your interested investors",
          link: "data-collection",
        },
        {
          title: "Employee Benefit",
          description: "Keep your most treasured talents and manage them better",
          link: "data-collection",
        },
        {
          title: "API Client",
          description: "Connect your users with startup investments from within your platform.",
          link: "data-collection",
        },
        {
          title: "Credit Provider",
          description: "Provide investment backed credit to retail investors on the GetEquity platform",
          link: "onboard-setup",
        },
        {
          title: "Treasury",
          description: "Manage investment in high yield liquid investment products for treasury",
          link: "onboard-setup",
        },
      ],
    };
  },

  methods: {
    setAccountType(type) {
      if (type.title === "Private Raise") {
        this.$router.push({ name: "DataCollection", params: { type: "private-raise" } });
      }
      if (type.title === "Public Raise") {
        window.location = "https://airtable.com/shrNQr1FF3Io52cCO";
      }
      if (type.title === "Employee Benefit") {
        this.$router.push({ name: "DataCollection", params: { type: "employee-benefit" } });
      }
      if (type.title === "API Client") {
        this.$router.push({ name: "DataCollection", params: { type: "api-client" } });
      }
      if (type.title === "Credit Provider") {
        this.$router.push({ name: "DataCollection", params: { type: "credit-provider" } });
      }
      if (type.title === "Treasury") {
        this.$router.push({ name: "DataCollection", params: { type: "invest" } });
      }
    },

    getShortText(title) {
      const texts = {
        "Public Raise": "Raise funds for your startup publicly, from GetEquity's community of investors",
        "Private Raise": "Create deal rooms to raise privately, manage investors under one SPV",
        "Employee Benefit": "Create ESOP's or RSU's and give benefits to your employees with ease.",
        "API Client": "Connect your users with Investment opportunities from startups to fixed income to equity deals from your platform",
        "Credit Provider": "Provide investment backed credit to retail investors on the GetEquity platform",
        "Treasury": "Manage investment in high yield liquid investment products for treasury",
      };
      return texts[title] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.product-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.product-card {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:hover {
    border-color: #4D84FF;
    box-shadow: 0 4px 20px rgba(77, 132, 255, 0.12);
    transform: translateY(-2px);

    .product-card__arrow {
      transform: translateX(4px);
      color: #4D84FF;
    }

    .product-card__icon {
      background: linear-gradient(135deg, #4D84FF 0%, #3B6FE8 100%);
      color: white;
    }
  }

  &__icon {
    width: 48px;
    height: 48px;
    background: #F1F5F9;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748B;
    transition: all 0.2s ease;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #0F172A;
    margin: 0;
  }

  &__arrow {
    color: #CBD5E1;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  &__description {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
    line-height: 1.5;
  }
}
</style>
